<template>
  <div v-if="stock" id="stock-comments">
    <HeaderSidebarRight :id_header="id_header" :title_header="title_header" />
    <div v-if="_g_UserFeatures.permissions.read_forum" class="content-container">
      <h4 v-if="_isPlatinum()">{{ comments_splited.length }} comentarios</h4>
      <div id="comments-body">
        <div class="info-ticker-box">
          <p class="text-info-ticker">Ticker: <span class="text-bold">{{ stock.ticker }}</span></p>
        </div>

        <p class="comment-count-text text-bold">{{ comments_splited.length }} COMENTARIOS</p>
        <hr class="first-line">
        <div id="no-comment-text-container" v-if="comments_splited.length == 0">
          <p class="no-comment-text">Aún no hay comentarios para este ticker</p>
        </div>
        <div v-else id="comments-wrapper">
          <div v-for="comment in comments_splited" :key="comment.id" class="comment-wrapper">
            <div v-if="comment.new > 0">
              <span class="material-icons-outlined">new_releases</span>
            </div>
            <div id="comment">
              <div class="user-box">
                <div v-if="comment.picture_src.indexOf('tthh_default.gif') != -1" class="comment-user-main-container">
                  <div class="comment-user-container">
                    <div>
                      <i class="material-icons comment-icon-user" style="font-size: 50px">supervised_user_circle</i>
                    </div>
                    <div class="date-container">
                      <span class="date-text">{{ comment.date }}</span>
                    </div>
                  </div>
                  <div class="name-and-member">
                    <span class="name-text">{{ comment.name }}</span>
                    <span class="member-since-text">{{ comment.member_since }}</span>
                  </div>
                </div>
                <div v-else id="comment-user" class="comment-user-main-container">
                  <div class="comment-user-container">
                    <div>
                      <img :typeof="comment.picture_typeof" :src="comment.picture_src" :alt="comment.picture_alt"
                        :title="comment.picture_title" class="user-image-comment">
                    </div>
                    <div class="date-container">
                      <span class="date-text">{{ comment.date }}</span>
                    </div>
                  </div>
                  <div class="name-and-member">
                    <span class="name-text">{{ comment.name }}</span>
                    <span class="member-since-text">{{ comment.member_since }}</span>
                  </div>
                </div>
              </div>
              <p id="comment-text" style="font-size: 14px;">{{ comment.message }}</p>
              <div id="comment-rating">
                <span @click="upComment(comment)" class="comment-icon material-icons">sentiment_satisfied_alt</span>
                <span @click="downComment(comment)" class="comment-icon material-icons">sentiment_very_dissatisfied</span>
                <span class="comment-text">Puntos: <span class="text-bold-points">{{ comment.votes }}</span> </span>
              </div>
              <hr>
            </div>
          </div>
        </div>
      </div>
      <div id="comment-writer" v-if="_g_UserFeatures.permissions.forum_writer">
        <div class="comment-box">
          <InputTextarea id="input_comment" @_emit_method_order_input_textarea="_getInputValue" :ref="input_comments.ref"
            :input_key_to_textarea_values="input_comments.input_key_to_textarea_values"
            :input_placeholder="input_comments.input_placeholder" />
          <Button id="comment-button-id" @_emit_method_button="_createComment" :button_name="button_name"
            :button_key="button_key_comments" :button_icon_permission="true" :button_icon="button_icon"
            :button_icon_id="button_icon_id" style="margin-bottom: 32px;" />
        </div>
      </div>
    </div>
    <div v-else class="not-available-data-container">
      <div class="info-ticker-box">
        <p class="text-info-ticker">Ticker: <span class="text-bold">{{ stock.ticker }}</span></p>
      </div>
      <p class="not-available-data typo-body-2"> Su plan actual no tiene acceso a esta herramienta. </p>
      <a href="/app/store" class="link-to-store typo-body-2"> Pulse aquí para cambiar de plan. </a>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import InputTextarea from "@/components/helpers/InputTextarea.vue";
import Button from "@/components/helpers/Button";
import InputComments from "./configs/input_comments.json";
import HeaderSidebarRight from './HeaderSidebarRight.vue';
import APICaller from "@/components/codeComponents/APICaller.js";
export default {
  mixins: [APICaller],
  name: 'Comments',
  components: {
    InputTextarea,
    Button,
    HeaderSidebarRight
  },
  data: function () {
    return {
      comments: [],
      new_comment: '',
      button_name: "",
      button_key_comments: "button_comments",
      button_icon: "done",
      button_icon_id: "icon_button_comment",
      input_comments: InputComments,
      id_header: 'comments-header',
      title_header: 'Foro del valor',
      comments_splited: [],
    }
  },
  watch: {
    stock: {
      handler: function (newVal, oldVal) {
        if (newVal.id != oldVal.id) {
          this._getComments();
        }
      },
      deep: true
    },
  },
  mounted() {
    this._changeColorTextarea();
  },
  created: function () {
  },
  computed: {
    ...mapGetters({ stock: '_g_SelectedTicker' }),
    ...mapGetters({ user: '_g_User' }),
    ...mapGetters({ active_right_component: "_g_Active_right_component" }),
    ...mapGetters(["_g_UserFeatures"]),
  },
  methods: {
    _getInputValue(value) {
      this.new_comment = value[0]
    },
    _isPlatinum() {
      return this.user.is_platinum_user;
    },

    _getComments: function () {
      let success = response => {
        this.comments_splited = [];
        this.comments = response.data;
        this._spliterInfoGetComments()
      }

      let url = "/api/v1/forum/comments/" + this.stock.nid;

      const successHandler = new APICaller.SuccessHandler(success);
      const failureHandler = new APICaller.FailureHandler('044', 'Error recuperando comentarios.');

      this._getAPICall(url, successHandler, failureHandler);
    },

    _createComment: function () {
      if (this.new_comment != '') {
        var params = new URLSearchParams();
        params.append('new_comment', this.new_comment);

        let success = response => {
          if (response.data.status == 'ok') {
            this.$vueOnToast.pop('success', "Comentario", "Enviado con exito!");
            this._getComments();
          } else {
            this.$vueOnToast.pop('error', "Comentario no creado", response.data.message);
          }
        }

        let url = '/api/v1/forum/comments/add/' + this.stock.nid;

        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('246', 'Error añadiendo comentarios.');

        this._postAPICall(url, params, successHandler, failureHandler);
      }
    },

    _changeColorTextarea() {

      let inputComment = document.getElementById("input_comment");

      inputComment.addEventListener('click', function () {

        for (let inputTextfieldComment of document.getElementsByClassName("comments_input")) {
          inputTextfieldComment.style.backgroundColor = "#EDF8FB";
        }
        let iconColorComment = document.getElementById("icon_button_comment")
        iconColorComment.style.color = "#FFFFFF";

        let buttonColorComment = document.getElementById("comment-button-id")
        buttonColorComment.style.backgroundColor = "#00AEDD"
      });

    },
    upComment: function (comment) {
      this._voteComment(comment, 1);
      this._getComments();
    },
    downComment: function (comment) {
      this._voteComment(comment, -1);
      this._getComments();
    },

    _voteComment: function (comment, value) {
      var params = new URLSearchParams();
      params.append('vote_value', value);
      params.append('entity_id', comment.comment_id);

      let success = () => {
        this.$vueOnToast.pop('success', "Comentario", "Votado con exito");
        this._getComments();
      }

      let url = '/api/v1/forum/comments/vote/' + this.stock.nid

      const successHandler = new APICaller.SuccessHandler(success);
      const failureHandler = new APICaller.FailureHandler('247', 'Error votando comentarios.');

      this._postAPICall(url, params, successHandler, failureHandler);
    },

    _spliterInfoGetComments: function () {
      for (let i = 0; i < this.comments.length; i++) {
        let aux = this.comments[i].user.picture.split(">");
        let picture = aux[2] + ">";
        let picture_splited = picture.split(" ")
        let member_since = ""
        let date = ""
        let name = ""

        if (picture_splited[0].indexOf("Administrador") != -1) {
          picture = aux[6] + ">";
          picture_splited = picture.split(" ")

          member_since = aux[10].split("<");
          member_since = member_since[0];

          name = aux[12].split("<");
          name = name[0];

          date = aux[14].split("<");
          date = date[0];
        } else {
          member_since = aux[6].split("<");
          member_since = member_since[0];

          name = aux[8].split("<");
          name = name[0];

          date = aux[10].split("<");
          date = date[0];
        }

        let picture_typeof = picture_splited[1].split("=")
        picture_typeof = picture_typeof[1]

        let picture_src = picture_splited[2].split("=")
        picture_src = picture_src[1]

        let picture_alt = picture_splited[3].split("=")
        picture_alt = picture_alt[1] + " " + picture_splited[4] + " " + picture_splited[5]

        let picture_title = picture_splited[6].split("=")
        picture_title = picture_title[1] + " " + picture_splited[7] + " " + picture_splited[8]

        let nuevo = this.comments[i].new
        let comment_id = this.comments[i].comment_id
        let message = this.comments[i].message
        let votes = this.comments[i].user.votes.avg

        picture_alt = picture_alt.replace(/"/g, "")
        picture_title = picture_title.replace(/"/g, "")
        picture_src = picture_src.replace(/"/g, "")
        picture_typeof = picture_typeof.replace(/"/g, "")

        let commentToAdd = { "picture_typeof": picture_typeof, "picture_src": picture_src, "picture_alt": picture_alt, "picture_title": picture_title, "member_since": member_since, "name": name, "date": date, "new": nuevo, "comment_id": comment_id, "message": message, "votes": votes };
        this.comments_splited.push(commentToAdd);
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.comment-box {
  display: flex;
  align-items: center;
  margin: 20px 0px;
}

.material-icons-outlined {
  cursor: pointer;
}

.info-ticker-box {
  width: 100%;
  display: flex;
  justify-content: center;
}
.material-icons.comment-icon-user {
  color: var(--color-text-primary);
}


.text-info-ticker {
  text-align: center;
  background-color: var(--color-surface);
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.15px;
  margin-bottom: 12px;
  margin-top: 0px;
  width: 50%;
  padding: 7px 20px;
}

.text-bold {
  font-weight: bold;
}

.comment-count-text {
  text-align: center;
  font-weight: bold;
  font-size: 14px;
  line-height: 12px;
  margin: 10px 0 20px;
  color: var(--color-text-primary);
}

hr {
  color: var(--color-outline);
  margin: 20px 0 24px;
  width: 100%;
}

#comment-user .user-picture {
  display: none;
}

#comment-user {
  font-size: 14px;
  width: 100%;
  color: var(--color-text-primary);
}

#comment-text,
.no-comment-text {
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--color-text-inactive);
}

#comment-rating {
  display: flex;
  justify-content: end;
  align-items: center;
  margin-top: 20px;
}

.comment-icon {
  margin: 0 2px;
  cursor: pointer;
}

.comment-text {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  margin-left: 2px;
  color: var(--color-text-primary);
}

.text-bold {
  font-weight: bold;
}

.user-box {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

#comment {
  margin: 0 20px;

}

.comment-wrapper:last-child {
  margin-bottom: 200px;
}

.comment-icon-user {
  font-size: 40px;
  margin-right: 15px;
}

#comment-writer {
  bottom: 24px;
  border-top: 0.5px solid var(--color-outline);
  width: 100%;
  height: 109px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  position: absolute;
  background-color: var(--color-background);
}

.comment-box {}

#comments-wrapper {
  margin-bottom: 200px;
  height: 80%;
  overflow-y: scroll;
  position: absolute;
}

.first-line {
  width: 100%;
}

#stock-comments {
  width: 100%;
  background-color: var(--color-background);
}

#no-comment-text-container {
  text-align: center;
}

.comment-user-container {
  display: flex;
  flex-direction: row;
}

.name-and-member {
  display: flex;
  flex-direction: column;
  margin-top: 7px;
}

.name-text {
  font-size: 16px;
  font-weight: bold;
}

.member-since-text {
  font-size: 10px;
}

.date-text {
  font-size: 14px;
  font-weight: bold;
  margin-top: 10px;
  margin-left: 4px;
}

.user-image-comment {
  height: 42px;
  width: 42px;
  margin-right: 15px;
  border-radius: 50px;
  padding: 1px;
}

#stock-comments .text-info-ticker,
#stock-comments .text-info-ticker span {
  background-color: var(--custom-color-right-menu-highlight);
  color: var(--custom-color-right-menu-font);
}

#stock-comments span,
#stock-comments .text-info-title {
  color: var(--custom-color-right-menu-font) !important;
}

.not-allowed-forum {
  text-align: center;
  margin-top: 20px;
  color: #FF9B00;
  font-weight: 500;
}

.not-available-data-container {
  text-align: center;
  background-color: var(--color-surface);
}

.not-available-data {
  color: #FF9B00;
}

.link-to-store {
  color: var(--color-text-link);
}


.content-container {
  height: 100%;
}
</style>